<template>
    <div>
        <Header v-cloak></Header>
        <FrontTitle v-cloak></FrontTitle>
        <HomeMain v-cloak></HomeMain>
        <HomeFoot v-cloak></HomeFoot>
        <FixedGuanggao v-cloak></FixedGuanggao>
    </div>
</template>

<script>
  // @ is an alias to /src
  import Header from '@/components/Header.vue'
  import FrontTitle from '@/components/FrontTitle.vue'
  import HomeMain from '@/components/HomeMain.vue'
  import HomeFoot from '@/components/HomeFoot.vue'
  import FixedGuanggao from '@/components/FixedGuanggao.vue'

  export default {
    name: 'home',
    components: {
      Header, FrontTitle, HomeMain, HomeFoot, FixedGuanggao
    },
    data () {
      return {}
    },
    created () {},
    mounted () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
</script>
<style lang="less" scoped>
    @import url("../assets/css/view/index.css");
</style>
